import {useContext} from 'react';
import moment from 'moment';
import { useTranslator } from '@jutro/locale';
import { MLLocalDateUtil } from 'ml-portals-util-js';
import messages from './MLActivityDateUtil.messages';

import { IntlContext } from '@jutro/legacy/locale';

const today = moment();
const yesterday = moment().subtract(1, 'days');
const tomorrow = moment().add(1, 'days');

function MLActivityDateUtil() {
    const intl = useContext(IntlContext);
    const translator = useTranslator();

    const getActivityDate = (aDate) => {
        if (aDate && aDate.year) {
            aDate = MLLocalDateUtil.localDate2Date(aDate);
        }
        const date = moment(aDate);
        if (!aDate) {
            return '—';
        } 
        if (date.isSame(yesterday, 'd')) {
            return translator(messages.yesterday);
        } 
        if (date.isSame(today, 'd')) {
            return translator(messages.today);
        } 
        if (date.isSame(tomorrow, 'd')) {
            return translator(messages.tomorrow);
        }
    
        return intl.formatDate(date, { year: 'numeric', month: '2-digit', day: '2-digit' });
    };

    const toLocaleTimeStamp = (aDate) => {
        if (aDate && aDate.year) {
            // To Convert the Date to Local Date
            aDate = MLLocalDateUtil.serverDateToLocalDate(aDate);
        }
        
        if (!aDate) {
            return "—";
        }

        const date = moment(aDate);
        
        return date.format("MM/DD/YYYY,h:mmA");
    };

    return {
        getActivityDate,
        toLocaleTimeStamp
    };
}


export default MLActivityDateUtil;